<template>
  <div class="sf" :style="sfStyle">
    <avue-crud :option="option"
               :data="data"
               :page="page"
               ref="crud"
               @search-change="searchChange"
               @search-reset="refreshChange"
               @size-change="sizeChange"
               @current-change="currentChange"
               @refresh-change="refreshChange"
               :row-style="rowStyle"
               @selection-change="selectionChange">
      <template slot="menuLeft">
        <el-button type="primary"
                   icon="el-icon-circle-plus"
                   @click="addSf"
                   size="mini">新 增
        </el-button>
        <el-button type="danger"
                   icon="el-icon-document"
                   @click="$router.push({path:'/pay-list'})"
                   size="mini">订单管理
        </el-button>
        <el-button
                   icon="el-icon-s-order"
                   @click="setFlag"
                   size="mini">签 订
        </el-button>
        <el-button
                   icon="el-icon-s-order"
                   @click="getFlag"
                   size="mini">未签列表
        </el-button>
      </template>
      <template slot-scope="scope"
                slot="menu">
        <el-button type="text"
                   icon="el-icon-edit"
                   @click="editSf(scope.row)"
                   size="small">修 改
        </el-button>
        <el-button type="text"
                   icon="el-icon-setting"
                   @click="setBuild(scope.row)"
                   size="small">修改授权
        </el-button>
      </template>
    </avue-crud>
    <el-dialog title="发票信息"
               top="40px"
               :before-close="beforeClose"
               :visible.sync="sfbox"
               width="500px">
      <avue-form ref="sfform" :option="sfoption"
                 @submit="sfSubmit"
                 v-model="sfform">
      </avue-form>
    </el-dialog>
    <auth ref="auth"
          @submit="getList">
    </auth>
  </div>
</template>

<script>
import {mapState} from 'vuex';
import Record from '@/util/record'
import {validatenull} from "@/util/validate";

export default {
  data() {
    const qqChange = (value) => {
      if (validatenull(value)) {
        this.sfform.email = '';
      } else {
        this.sfform.email = `${value}@qq.com`;
      }
    };
    return {
      sliderVisible: true, // 控制slider的显示
      data: [],
      selectlist: [],
      page: {
        currentPage: 1,
        total: 0,
        pageSizes: [10, 30, 50, 100, 200, 1000],
        pageSize: 10
      },
      sfform: {},
      sfbox: false,
      sfoption: {
        size: 'mini',
        emptyBtn: false,
        column: [{
          label: '合同编号',
          prop: 'contract',
          span: 24,
        }, {
          label: '授权版本',
          prop: 'version',
          span: 24,
        }, {
          label: '授权分组',
          prop: 'group',
          span: 24,
        }, {
          label: '姓名',
          prop: 'name',
          search: true,
          rules: [{
            required: true,
            message: "请输入姓名",
            trigger: "blur"
          }],
          span: 24,
        }, {
          label: '身份证',
          prop: 'code',
          search: true,
          rules: [{
            required: true,
            message: "请输入身份证",
            trigger: "blur"
          }],
          span: 24,
        }, {
          label: 'qq',
          search: true,
          prop: "qq",
          rules: [{
            required: true,
            message: "请输入qq",
            trigger: "blur"
          }],
          span: 24,
          change: ({value, column}) => qqChange(value, column)
        }, {
          label: '邮箱',
          prop: "email",
          rules: [{
            required: true,
            message: "请输入邮箱",
            trigger: "blur"
          }],
          span: 24,
        }, {
          label: '手机号',
          prop: 'phone',
          rules: [{
            required: true,
            message: "请输入手机号",
            trigger: "blur"
          }],
          span: 24,
        }, {
          label: '备注',
          prop: 'remark',
          type: 'textarea',
          span: 24,
        }]
      },
      option: {
        size: 'mini',
        align: "center",
        menuAlign: 'left',
        headerAlign: 'center',
        index: true,
        excelBtn: true,
        selection: true,
        addBtn: false,
        delBtn: false,
        viewBtn: true,
        editBtn: false,
        tip: false,
        column: [{
          width: 120,
          label: '授权版本',
          prop: 'version'
        }, {
          label: '授权分组',
          prop: 'group',
          width: 180,
        }, {
          label: '姓名',
          prop: 'name',
          width: 80,
          search: true,
        }, {
          label: '身份证',
          prop: 'code',
          search: true,
        }, {
          width: 180,
          label: 'qq',
          search: true,
          prop: "qq"
        }, {
          width: 180,
          label: '邮箱',
          prop: "email"
        }, {
          width: 180,
          label: '手机号',
          prop: 'phone'
        }, {
          width: 180,
          label: '日期',
          prop: 'datetime'
        }, {
          label: '备注',
          prop: 'remark'
        }]
      },
    }
  },
  computed: {
    sfStyle() {
      // 根据 sliderVisible 状态返回不同的 padding
      return this.sliderVisible
        ? { padding: '100px 10px 100px 10px' } // 默认 padding
        : { padding: '200px 10px 100px 10px' }; // slider 隐藏时的 padding
    },
    ...mapState(['user', 'pwd']),
  },
  created () {
    const handleResize = () => {
      this.sliderVisible = window.innerWidth > 768;
    };
    handleResize(); // 确保首次加载时执行
    window.addEventListener('resize', () => {
      this.sliderVisible = window.innerWidth > 768;
      this.$forceUpdate(); // 强制更新视图
    });
  },
  methods: {
    searchChange(params) {
      this.getList(params)
    },
    selectionChange(list) {
      this.selectlist = list;
    },
    addSf() {
      this.sfbox = true
    },
    editSf(row) {
      this.sfform = row;
      this.sfbox = true
    },
    sfSubmit(form, done) {
      form = this.deepClone(this.sfform);
      if (!form.datetime) form.datetime = (new Date()).Format('yyyy.MM.dd');
      if (form.objectId) {
        delete form.flag;
        delete form.datetime;
        this.update(form.objectId, form, 'x_identity').then(() => {
          this.sfbox = false;
          this.$message.success('实名信息修改成功');
          this.getList();
          done();
        })
      } else {
        delete form.objectId;
        delete form.createdAt;
        delete form.updatedAt;
        form.flag = false;
        this.insert(form, 'x_identity').then(() => {
          this.sfbox = false;
          this.$message.success('实名信息提交成功');
          this.getList();
          done();
        })
      }
    },
    insert(data, table) {
      const query = new Record(table || 'x_identity');
      const entity = {};
      Object.keys(data).forEach(ele => {
        if (ele.includes('$')) {
          entity[ele.replace('$', '') + '_text'] = data[ele];
        } else {
          if (!ele.includes("auth") && !ele.includes("token")) {
            entity[ele] = data[ele];
          } else {
            query.auth(true);
            query.username(this.user);
            query.token(this.token);
          }
        }
      })
      query.entity(entity);
      return query.save()
    },
    update(id, data, table) {
      const form = this.deepClone(data);
      const query = new Record(table || 'x_identity');
      const entity = {};
      entity['id'] = id;
      delete form.createdAt;
      delete form.updatedAt;
      delete form.objectId;
      Object.keys(form).forEach(ele => {
        if (!ele.includes('$')) {
          if (form[ele]) {
            entity[ele] = form[ele]
          }
        }
      })
      query.entity(entity);
      return query.update()
    },
    rowStyle({row}) {
      if (!row.flag) {
        return {
          backgroundColor: 'rgba(245,108,108,0.1)'
        }
      }
    },
    setFlag() {
      this.selectlist.forEach(ele => {
        const query = new Record('x_identity');
        const entity = {};
        entity['id'] = ele.objectId;
        entity['flag'] = 1;
        this.$set(this.data[ele.$index], 'flag', 1);
        query.entity(entity);
        return query.update();
      });
      this.$refs.crud.toggleSelection();
      this.$message.success('设置成功')
    },
    getFlag() {
      this.getList({flag: 0})
    },
    setBuild(row) {
      window.open(`https://center.javablade.com/org/blade/teams/${row.group}`, '_blank')
    },
    beforeClose(done) {
      this.$refs.sfform.resetForm();
      done()
    },
    currentChange(val) {
      this.page.currentPage = val;
      this.getList()
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.getList()
    },
    refreshChange() {
      this.data = [];
      this.$message.success('刷新成功')
      this.getList();
    },
    getList(params) {
      if (this.validatenull(this.pwd)) return;
      if (this.user !== 'bladex') return;
      const query = new Record('x_identity');
      query.count().then(res => {
        this.page.total = res.data;
        const next = (this.page.currentPage - 1) * this.page.pageSize;
        query.limit(this.page.pageSize)
        query.skip(next)
        query.order("-updatedAt");
        for (let o in params) {
          query.equalTo(o, " like ", `'%${params[o]}%'`);
        }
        return query.find()
      }).then(res => {
        const data = res.data;
        data.forEach(d => {
          d.datetime = new Date(d.datetime).Format("yyyy.MM.dd");
        })
        this.data = data;
      });
    }
  },
}
</script>

<style lang="scss">
.sf {
  min-height: 700px;
}

input[type=number] {
  width: 35px !important;
}
</style>
